import React from "react";
import s from './CornerImage.module.css'
import corner_img from '../../assets/img/corner_img.png'

const CornerImage = () => {
  return <img className={s.corner_img} src={corner_img} alt="img" />
};

export default CornerImage;
